import React from 'react';
import { Jumbotron, Row, Container } from 'react-bootstrap';
import SpinnerCard from './SpinnerCard';

function BookingThankYou(props) {

    function isShown() {
        return props.shownControl === 'thankyou';
    }

    function isSaved() {
        return props.saveStatus === 200
    }

    function isLoading() {
        return !props.saveStatus;
    }

    if (!isShown()) {
        return <div></div>;
    } else if (isLoading()) {
        return (
            <Container>
                <Row className="justify-content-center align-items-center row-eq-height">
                    <SpinnerCard />
                </Row>
            </Container>
        );

    } else if (!isSaved()) {
        return (
            <Jumbotron variant="error">
                <h1>Något verkar ha gått fel med din bokning!</h1>
                <p>
                    Försök att göra om din bokning, eller kontakta det företag
                    du försöker boka hos för mer information.
                </p>
            </Jumbotron>
        );
    } else {
        return (
            <Jumbotron variant="thankyou">
                <h1>Tack för din bokning hos {props.customerData.settings.CompanyName}!</h1>
                <p>
                    En bekräftelse har skickats till den mail du angav i bokningen.
                    I mailet finns även en länk för att avboka upp till 24 timmar
                    innan bokningstillfället.
            </p>
            </Jumbotron>
        );
    }
}

export default BookingThankYou;